var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.style.productEditPage},[_c('product-price-setting-table',{attrs:{"productId":_vm.productId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }